// import { usePoderiStore } from '../stores/poderiStore'
import { useAppStore } from '../stores/app'
import { useSkinStore } from "../stores/skinStore.js";
import { useChatStore } from '../stores/chatStore.js';
import { isNative } from '../services/platform.js'
import { getMisura21Access } from '../modules/misura21/misura21Access.js'
import { useI18n } from 'vue-i18n'
/**
 * Composable per la gestione centralizzata delle sidebar
 */
export function useSidebar() {
  // const poderiStore = usePoderiStore()
  const appStore = useAppStore();
  const skinStore = useSkinStore();
  const chatStore = useChatStore();
  const { t } = useI18n();

  /**
   * Voci comuni in cima a tutte le sidebar: Home + (se autenticato) Aziende, Feed, Parla con Poderi.
   */
  function getSidebarTop() {
    const items = [
      { id: 'home', label: t('nav.home'), icon: 'Home', to: '/' },
    ];
    if (appStore.isAuthenticated) {
      items.push(
        { id: 'poderi', label: t('nav.farms'),        icon: 'Building2', to: '/poderi' },
        { id: 'feed',   label: t('nav.activityFeed'), icon: 'Rss',       to: '/feed'   },
      );
      if (
        appStore.isAuthenticated && appStore.hasFeatureFlag("parlaconpoderi")
      ) {
        items.push({
          id: "parlacon",
          label: t('nav.talkToPoderi'),
          icon: "Mic",
          to: "/parlacon",
        });
      }
      if (appStore.isAuthenticated && appStore.hasFeatureFlag("doc_org")) {
        items.push({
          id: "doc-org",
          label: t('nav.documents'),
          icon: "FileText",
          to: "/docs",
        });
      }

    }
    return items;
  }

  /**
   * Sidebar di root - Navigazione principale dell'applicazione
   */
  function getSidebarRoot() {
    const sb = getSidebarTop();


    sb.push(...getSidebarPost());
    return sb;
  }



  //Sidebar da aggiungere dopo il root e l'azienda (con le funzioni featureFlag generiche)
  function getSidebarPost() {
    let sb = [];


    // SRH01 (Misura 2.1): voci per ruolo da getMisura21Access (condivise col blocco in Home).
    const m21 = getMisura21Access(appStore);
    if (m21.enabled && m21.links.length) {
      if (m21.isOrgUser) {
        sb.push({ id: 'misura21-sep', separator: true })
        sb.push({ id: "misura21-label", label: "SRH01" });
        sb.push(...m21.links)
        sb.push({ separator: true })
      } else {
        sb.push(...m21.links)
      }
    }

    

    if (appStore.hasRole("org_admin")) {

      // sb.push({"separator": true})

      sb.push(
        {
          id: "farm-name",
          label: t('nav.organization'),
        }
      );

      sb.push(
        {
          id: "org-admin",
          label: t('nav.manageOrg'),
          icon: "ShieldCheck",
          to: "/org-admin",
        },
      );


      sb.push({
        id: "admin-dbmng",
        label: t('nav.manageSchemas'),
        icon: "Database",
        to: "/admin-dbmng",
      });
      


      if (appStore.hasFeatureFlag("oliverec")) {
        //gestione delle accessioni, se è attiva la feature flag
        sb.push({
          id: "accessions",
          label: t('nav.accessions'),
          icon: "Droplets",
          to: "/accessions",
        });
        sb.push({
          id: "accessions-elab",
          label: t('nav.accessionsElab'),
          icon: "BarChart2",
          to: "/accessions/elab",
        });
        sb.push({
          id: "ai",
          label: t('nav.aiTagging'),
          icon: "BrainCircuit",
          to: "/ai",
        });
      }


      sb.push(  { separator: true } );

    }



    if (appStore.hasRole("admin")) {
      sb.push({
        id: "admin",
        label: "Admin",
        icon: "ShieldAlert",
        children: [
          { id: "admin-users",     label: t('nav.users'),              to: "/admin/users" },
          { id: "admin-orgs",      label: t('nav.adminOrgs'),          to: "/admin/orgs" },
          { id: "admin-varieties", label: t('nav.adminVarieties'),     to: "/admin/varieties" },
          { id: "admin-dbmng",     label: t('nav.manageSchemas'),      to: "/admin-dbmng" },
          { id: "admin-notifiche", label: t('nav.notifications'),      to: "/admin/notifiche" },
          { id: "admin-chat",      label: t('nav.adminChat'),          to: "/admin/chat" },
          { id: "admin-celery",    label: "Celery",                    to: "/admin/celery" },
          { id: "admin-rs",        label: "Remote Sensing",            to: "/admin/rs" },
          { id: "admin-aepest",    label: t('nav.adminPlantHealth'),   to: "/admin/aepest" },
          { id: "admin-bdf",       label: t('nav.adminBdf'),           to: "/admin/bdf" },
          { id: "admin-weather",   label: t('nav.adminWeather'),       to: "/admin/weather" },
          { id: "admin-spatial",   label: t('nav.adminSpatialModel'),  to: "/admin/spatial-model" },
          { id: "admin-stato",     label: t('nav.adminSystemStatus'),  to: "/admin/stato" },
        ],
      });
    }




    // sb.push(
    //   {
    //     id: 'settings',
    //     label: 'Impostazioni',
    //     icon: 'Settings',
    //     to: '/settings'
    //   }
    // )

    // Profilo utente, messaggi e notifiche (visibili per tutti gli utenti autenticati)
    if (appStore.isAuthenticated) {
      sb.push({
        id: "chat",
        label: t('nav.messages'),
        icon: "MessageSquare",
        to: "/chat",
        badge: chatStore.totalUnread > 0 ? chatStore.totalUnread : null,
      });
      if (isNative()) {
        sb.push({
          id: "notifiche",
          label: t('nav.notifications'),
          icon: "Bell",
          to: "/notifiche",
          badge: appStore.unreadCount > 0 ? appStore.unreadCount : null,
        });
      }
      sb.push({
        id: "profile",
        label: t('nav.profile'),
        icon: "UserCircle",
        to: "/profile",
      });
    }

    //se la skin è virtualfarm aggiungo la voce per il virtual farm manager
    if (skinStore?.skin?.id === "virtualfarm") {
      sb.push(
        {
        id: "virtual-farm",
        label: t('nav.virtualFarms'),
        icon: "Monitor",
        to: "/aziende",
      });
    }

    sb.push({
      id: "credits",
      label: t('nav.credits'),
      icon: "Info",
      to: "/credits",
    });

    sb.push({
      id: "contact",
      label: t('nav.contact'),
      icon: "Mail",
    });

    return sb;
  }

  /**
   * Sidebar per una specifica azienda agricola
   * @param {string} farmCenterId - ID dell'azienda
   * @param {object} farmCenter - Oggetto azienda (opzionale, per mostrare nome)
   */
  function getSidebarFarm(farmCenterId, farmCenter = null) {
    const items = [...getSidebarTop(), { separator: true }];

    // Sezione azienda corrente
    if (farmCenterId) {
      items.push(
        {
          id: "farm-name",
          label: farmCenter?.name || t('farm.defaultName'),
        },
        {
          id: "farm-detail",
          label: t('farm.farmHome'),
          icon: "Home",
          to: `/poderi/${farmCenterId}`,
        },
        //Non è ancora pronta - meglio toglierla
        // {
        //   id: "farm-crop-rotation",
        //   label: t('farm.cropRotation'),
        //   icon: "RefreshCw",
        //   to: `/poderi/${farmCenterId}/crop-rotation`,
        // },
        {
          id: "farm-operations",
          label: t('farm.operations'),
          icon: "ListChecks",
          to: `/poderi/${farmCenterId}/operations`,
        },
        {
          id: "farm-observations",
          label: t('farm.monitoring'),
          icon: "ScanSearch",
          to: `/poderi/${farmCenterId}/observations`,
        },
        {
          id: "farm-dss",
          label: t('farm.weatherDss'),
          icon: "CloudSunRain",
          to: `/poderi/${farmCenterId}/dss`,
        },
        {
          id: "farm-soils",
          label: t('farm.soils'),
          icon: "Layers",
          to: `/poderi/${farmCenterId}/soils`,
        },
        {
          id: "farm-warehouse",
          label: t('farm.warehouse'),
          icon: "Package",
          to: `/poderi/${farmCenterId}/warehouse`,
        },
        {
          id: "farm-marketing",
          label: t('farm.marketing'),
          icon: "Megaphone",
          to: `/poderi/${farmCenterId}/marketing`,
        },
        {
          id: "farm-team",
          label: t('farm.team'),
          icon: "Users",
          to: `/poderi/${farmCenterId}/team`,
        },
      );

      //FeatureFlag abilitata per tutti - in futuro si può usare un feature flag specifica per lo zoo
      // if (appStore.hasFeatureFlag('zoo') || localStorage.getItem('zoo_dev') === 'true') {
        items.push(
          {
            id: 'farm-zoo',
            label: t('farm.livestock'),
            icon: 'PawPrint',
            to: `/poderi/${farmCenterId}/zoo`,
          },
        )
      // }


      

      if (appStore.hasFeatureFlag('oliverec')) {
        items.push(
          {
            id: "farm-plantrec",
            label: t('farm.plantrec'),
            icon: "Leaf",
            to: `/poderi/${farmCenterId}/plantrec`,
          },
          {
            id: "farm-enrichment",
            label: t('farm.openData'),
            icon: "Cloud",
            to: `/poderi/${farmCenterId}/enrichment`,
          },
        );
      }

      items.push({ separator: true })
    }

    //Aggiungi sidebar generali (dipendono da feature flag, ma non da azienda specifica)
    items.push(...getSidebarPost());

    

    return items;
  }

  /**
   * Sidebar per amministrazione organizzazione
   */
  function getSidebarOrgAdmin() {
    return [
      {
        id: 'home',
        label: t('nav.home'),
        icon: 'Home',
        to: '/'
      },
      { separator: true },
      {
        id: 'org-users',
        label: t('nav.users'),
        icon: 'Users',
        to: '/org/users'
      },
      {
        id: 'org-settings',
        label: t('nav.organization'),
        icon: 'Building2',
        to: '/org/settings'
      },
      { separator: true },
      {
        id: 'settings',
        label: t('nav.settings'),
        icon: 'Settings',
        to: '/settings'
      }
    ]
  }

  /**
   * Ritorna sidebar items in base al contesto
   * @param {string} context - 'root', 'farm', 'org-admin'
   * @param {object} options - Opzioni aggiuntive (farmCenterId, farmCenter, etc.)
   */
  function getSidebarItems(context = 'root', options = {}) {
    switch (context) {
      case 'farm':
        return getSidebarFarm(options.farmCenterId, options.farmCenter)
      case 'org-admin':
        return getSidebarOrgAdmin()
      case 'root':
      default:
        return getSidebarRoot()
    }
  }

  return {
    getSidebarTop,
    getSidebarRoot,
    getSidebarFarm,
    getSidebarOrgAdmin,
    getSidebarItems
  }
}
